export default __webpack_public_path__ + "static/media/download.e915cce2.svg";